import { gql } from '@apollo/client'

/**
 * @deprecated use useGetFeed instead
 */
export const GET_FEEDS = gql`
  query getFeeds($offset: Int, $limit: Int, $filters: FeedFilters) {
    getFeeds(offset: $offset, limit: $limit, filters: $filters) {
      feeds {
        shared_from {
          label_id
        }
        editable
        gallery
        id
        body
        title
        argument_type
        created_at
        updated_at
        global_status
        properties
        product_id
        campaign_id
        tags {
          id
          label
          order_number
        }
        comments {
          id
          text
          updated_at
          campaign_id
          author {
            first_name
            last_name
            label_id
          }
        }
        lastEditor {
          last_name
          first_name
          email
        }
        author {
          last_name
          first_name
          email
        }
        product {
          name
          configuration
        }
        facts {
          chart
          position_current_at
        }
        campaign {
          id
          name
          owner_id
          unit_id
          label_id
          active
          unit {
            id
            name
          }
        }
        artist {
          id
          name
          spotify_id
          facebook_id
        }
      }
      total
    }
  }
`
